import { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

import { SingleDirectorUserFragment } from '../../generated/graphql';

class UserRegistrationWebApi {
  private hugotApiHttpClient: AxiosInstance;

  constructor({ hugotApiHttpClient }: { hugotApiHttpClient: AxiosInstance }) {
    this.hugotApiHttpClient = hugotApiHttpClient;
  }

  public signUpAsDirector = async (): Promise<SingleDirectorUserFragment> => {
    let response: AxiosResponse;

    try {
      response = await this.hugotApiHttpClient.post('/sign_up_director');
    } catch (err: any) {
      throw new SignUpFailed({
        status: (err as AxiosError).response!.status,
        responseBody: (err as AxiosError<string>).response!.data,
      });
    }

    return response.data as SingleDirectorUserFragment;
  };
}

export class SignUpFailed extends Error {
  public readonly name = 'SignUpFailed';
  public readonly message: string;
  public readonly status: number;
  public readonly responseBody: string;

  constructor({ status, responseBody }: { status: number; responseBody: string }) {
    super();

    this.status = status;
    this.responseBody = responseBody;
    this.message = `Signing up is failed. (${status})\n${responseBody}`;
  }
}

export default UserRegistrationWebApi;
